// extracted by mini-css-extract-plugin
export var wordContainer = "_p6-0";